import styles from "./styles.module.scss";
import union from "./img/union.png";
import gplay from "./img/gplay.png";
import appstore from "./img/appstore.png";
import stars from "./img/stars.png";

export const WalkyRate = () => {
  return (
    <div className={styles.rate}>
      <div className={styles.users}>
        <img src={union} />
        <div className={styles.usersCount}>
          <h4>4,280,000+</h4>
          <p>users kick-started their weight-loss routine with our app</p>
        </div>
        <img src={union} />
      </div>
      <div className={styles.stores}>
        <img src={appstore} />
        <div className={styles.averageRating}>
          <img src={stars} />
          <h4>4.6</h4>
          <p><strong>average rating</strong></p>
        </div>
        <img src={gplay} />
      </div>
      <div className={styles.footer}>
        98,027+ kg is what our users have lost over the last 6 month 😍
      </div>
    </div>
  );
};
